import { ENV } from "shared-tsi";
import { environmentBase } from "./environment.base";

export const environment = {
    ...environmentBase,
    production: false,
    name: ENV.DEV,
    apiService_Auth: '/backend-login',
    apiService: '/backend-soporte',
    apiService_Erp: '/backend-api',
    apiService_Report: '/backend-report',
    apiService_Export: '/backend-export',
    apiService_Produccion: '/backend-prod-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_Ia: '/backend-ia',
    apiService_FE: '/backend-fe',
    apiService_Notificaciones: '/backend-notification',
    apiService_Config: '/backend-config',
    apiService_CRM: '/backend-crm',
    apiService_Planilla: '/backend-planilla',
    apiService_Etiquetas: '/backend-etiquetas',
    recaptcha: {
        siteKey: '6Ld4ZT0sAAAAAG9XH7-7d4s_0EAIToZXpeeCJGO5',
    }
}